import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/media/media_1/page.tsx");
